module.exports = __webpack_public_path__ + "img/class_cover.b53463c9.png";